import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '@core/material/material.module';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { AppSnackbarComponent } from './app-snackbar/app-snackbar.component';
import { PageTitleComponent } from './page-title/page-title.component';
import { SearchFilterChipMultipleComponent } from './search-filter-chip-multiple/search-filter-chip-multiple.component';
import { SearchFilterChipRangeDateComponent } from './search-filter-chip-range-date/search-filter-chip-range-date.component';
import { SearchFilterChipComponent } from './search-filter-chip/search-filter-chip.component';
import { PageTitleWithBackButtonComponent } from './page-title-with-back-button/page-title-with-back-button.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { InfoLabelDescriptionComponent } from './info-label-description/info-label-description.component';
import { DialogInformationComponent } from './dialog-information/dialog-information.component';

@NgModule({
  declarations: [
    AppSnackbarComponent,
    PageTitleComponent,
    SearchFilterChipComponent,
    SearchFilterChipMultipleComponent,
    SearchFilterChipRangeDateComponent,
    PageTitleWithBackButtonComponent,
    ConfirmationDialogComponent,
    InfoLabelDescriptionComponent,
    DialogInformationComponent
  ],

  imports: [CommonModule, MaterialModule, NgxMaskDirective],
  exports: [
    AppSnackbarComponent,
    PageTitleComponent,
    SearchFilterChipComponent,
    SearchFilterChipMultipleComponent,
    SearchFilterChipRangeDateComponent,
    PageTitleWithBackButtonComponent,
    ConfirmationDialogComponent,
    InfoLabelDescriptionComponent,
    DialogInformationComponent
  ],
  providers: [provideNgxMask()],
})
export class ComponentsModule { }
